export default __webpack_public_path__ + "static/media/close.49af635e.svg";